import { FC, useState } from "react";
import { Alert, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BrokerForm } from "../brokerForm";
import { useSubmitBrokerOnboardingRequest } from "../../admin/brokerOnboardingRequests/queries";

export const RequestNewBroker: FC = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const submitRequest = useSubmitBrokerOnboardingRequest({
    onSuccess: () =>
      navigate("/brokers/my-requests", {
        state: { submitted: true }
      }),
    onError: (error) => setErrorMessage(error.message)
  });

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 1080,
        marginX: "auto",
        overflowY: "auto",
        paddingBottom: 3
      }}
    >
      {errorMessage && (
        <Alert severity="error" sx={{ marginTop: 2 }}>
          {errorMessage}
        </Alert>
      )}
      <BrokerForm
        onSubmit={(payload) => {
          setErrorMessage(null);
          submitRequest.mutate(payload);
        }}
        submitting={submitRequest.isPending}
        submitLabel="Submit request"
        onCancel={() => navigate("/brokers")}
      />
    </Box>
  );
};
